import moment from "moment";

// export const baseUrl = "http://localhost:3007";
export const baseUrl = "";

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = (obj) => Object.keys(obj).length === 0;

// ** Returns K format from a number
export const kFormatter = (num) =>
  num > 999 ? `${(num / 1000).toFixed(1)}k` : num;

// ** Converts HTML to string
export const htmlToString = (html) => html.replace(/<\/?[^>]+(>|$)/g, "");

export const checkRights = (admin, functionGoup) => {
  if (!admin || !admin.rights) {
    return false;
  }
  if (admin.super) {
    return true;
  }
  for (const [k, value] of Object.entries(admin.rights)) {
    if (value.function_group == functionGoup) {
      return true;
    }
  }

  return false;
}

export const calDistanceFromLatLng = (la1, lon1, la2, lon2) => {
  var R = 6371; // km
  var dLat = toRad(la2 - la1);
  var dLon = toRad(lon2 - lon1);
  var lat1 = toRad(la1);
  var lat2 = toRad(la2);

  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return parseFloat(d);
}

const toRad = (Value) => {
  return Value * Math.PI / 180;
}

// ** Checks if the passed date is today
const isToday = (date) => {
  const today = new Date();
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  );
};

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (
  value,
  formatting = { month: "short", day: "numeric", year: "numeric" }
) => {
  if (!value) return value;
  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value);
  let formatting = { month: "short", day: "numeric" };

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: "numeric", minute: "numeric" };
  }

  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem("userData");
export const getUserData = () => JSON.parse(localStorage.getItem("userData"));

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole) => {
  if (userRole === "admin") return "/";
  if (userRole === "client") return "/access-control";
  return "/login";
};

// ** React Select Theme Colors
export const selectThemeColors = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: "#76bc21", // for option hover bg-color
    // primary: "#7367f0", // for selected option bg-color
    primary: "#76bc21",
    neutral10: "#7367f0", // for tags bg-color
    neutral20: "#ededed", // for input border-color
    neutral30: "#ededed", // for input hover border-color
  },
});

export const sleep = (ms) => {
  return new Promise(r => setTimeout(r, ms));
}

// only for importing excel **DATE** format cell
export const handleExcelDate = (date_from_excel) => {
  return typeof (date_from_excel) == 'number' ? moment.utc(new Date(Math.round((date_from_excel - 25569) * 864e5))) : moment.utc(date_from_excel)
}


export const sliceArrayIntoChunks = (arr, chunkSize) => {
  const res = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize);
    res.push(chunk);
  }
  return res;
}

export const carTunnelTypeMapping = {
  moto: "",
  van: "small",
  5.5: "small",
  9: "medium",
  16: "large",
  24: "large",
};

export const voucherStatusMapping = {
  0: "草稿",
  1: "可使用",
  2: "停止",
};

export const MemberStatusOption = [
  { value: "", label: "請選擇狀態" },
  { value: 0, label: "審批中" },
  { value: 1, label: "正常" },
];

export const DriverStatusOption = [
  { value: "", label: "請選擇狀態" },
  { value: 0, label: "等待提交文件" },
  { value: 1, label: "等待審批" },
  { value: 2, label: "文件已完成，等待線上訓練" },
  { value: 3, label: "已拒絕" },
  { value: 4, label: "已完成註冊" },
  { value: 5, label: "待退台" },
  { value: 6, label: "已退台" },
  { value: 7, label: "暫停帳號" },
];

export const WALLET_REMIT_STATUS = {
  PENDING: 0,
  INPROGRESS: 1,
  ACCEPT: 2,
  CANCEL: 3,
};

export const WALLET_REMIT_MAPPING = [
  { value: "", label: "請選擇" },
  { value: 0, label: "待處理" },
  { value: 1, label: "處理中" },
  { value: 2, label: "已過數" },
  { value: 3, label: "已取消" },
];

export const DRIVER_STATUS = {
  PENDING: 0,
  WAITING: 1,
  ACCEPT: 2,
  REJECT: 3,
};

export const OPINION_TYPE_MAPPING = [
  { value: 1, label: "查詢" },
  { value: 2, label: "投訴" },
  { value: 3, label: "建議" },
  { value: 4, label: "讚賞" },
  { value: 6, label: "其他" },
];


// export const STATUS = [
//   { value: 0, label: "等待提交文件" },
//   { value: 1, label: "等待審批" },
//   { value: 2, label: "文件已完成，等待線上訓練" },
//   { value: 3, label: "已拒絕" },
//   { value: 4, label: "已完成註冊" },
//   { value: 5, label: "已封鎖帳號" },
//   { value: 6, label: "已刪除帳號" },
// ];

export const VEHICLES = [
  { label: "貨VAN", value: "van" },
  { label: "5.5噸貨車", value: "5.5" },
  { label: "9噸貨車", value: "9" },
  { label: "16噸貨車", value: "16" },
  { label: "24噸貨車", value: "24" },
];

export const DRIVER_STATUS_MAPPING = {
  1: "未接單",
  2: "已指派",
  3: "已上貨",
  4: "已完成",
  5: "已取消",
  6: "異常",
};

export const ORDER_APPROVAL_STATUS_MAPPING = {
  0: "未核實",
  1: "車隊核實",
  2: "客管核實",
};

export const ORDER_STATUS = {
  NON_READY: -1,
  NON_PAYMENT: 0,
  PAID: 1,
  PICKED_ORDER: 2,
  PICKED_CLIENT: 3,
  ARRIVED: 4,
  CANCEL: 5,
};

export const VEHICLE_TYPE_MAPPING = {
  van: "Van",
  5.5: "5.5噸貨車",
  9: "9噸貨車",
  16: "16噸貨車",
  24: "24噸貨車",
};

export const DriverStatusList = [
  "等待提交文件",
  "等待審批",
  "文件已完成，等待線上訓練",
  "已拒絕",
  "已完成註冊",
  "待退台",
  "已退台",
];

export const MemberStatusList = ["審批中", "正常"];

export const GOODS_MAPPING = {
  small: "小型",
  medium: "中型",
  large: "大型",
  xlarge: "超大型",
};

export const VehicleTypeOption = [
  { value: "", label: "請選擇車種" },
  { label: "貨VAN", value: "van" },
  { label: "5.5噸貨車", value: "5.5" },
  { label: "9噸貨車", value: "9" },
  { label: "16噸貨車", value: "16" },
  { label: "24噸貨車", value: "24" },
];

export const DISTRICT_TYPE_OPTIONS = [
  { label: "起點", value: "start" },
  { label: "終點", value: "end" },
];

export const DriverType = [
  { value: "", label: "請選擇司機類型" },
  { label: "司機", value: 1 },
  { label: "主管", value: 2 },
  { label: "管理層", value: 4 },
  { label: "跟車", value: 3 },
  { label: "外判司機", value: 6 },
  { label: "倉務員", value: 7 },
  { label: "高級倉務員", value: 8 },
];

export const EvidenceType = [
  { value: "", label: "請選擇簽收證明" },
  { label: "不需要", value: "0" },
  { label: "影相", value: "1" },
  { label: "簽名", value: "2" },
  { label: "影相或簽名", value: "3" },
  { label: "影相及簽名", value: "4" }
];

export const rejectReasonOption = [
  { label: "個人資料不正確", value: 0 },
  { label: "正式駕駛執照照片清晰度不足", value: 1 },
  { label: "正式駕駛執照資料不正確", value: 2 },
  { label: "正式駕駛執照資料已過期", value: 3 },
  { label: "香港永久性居民身份證照片清晰度不足", value: 4 },
  { label: "香港永久性居民身份證資料不正確", value: 5 },
  { label: "香港永久性居民身份證資料已過期", value: 6 },
  { label: "銀行卡(出糧戶口）照片清晰度不足", value: 7 },
  { label: "銀行卡(出糧戶口）資料不正確", value: 8 },
  { label: "銀行卡(出糧戶口）資料已過期", value: 9 },
  { label: "住宅證明(三個月內）照片清晰度不足", value: 10 },
  { label: "住宅證明(三個月內）資料不正確", value: 11 },
  { label: "住宅證明(三個月內）資料已過期", value: 12 },
  { label: "車輛保險照片清晰度不足", value: 13 },
  { label: "車輛保險資料不正確", value: 14 },
  { label: "車輛牌簿資料已過期", value: 15 },
  { label: "車輛牌照(行車證）照片清晰度不足", value: 16 },
  { label: "車輛牌照(行車證）資料不正確", value: 17 },
  { label: "車輛牌照(行車證）資料已過期", value: 18 },
  { label: "背景審查證明(三個月內）照片清晰度不足", value: 19 },
  { label: "背景審查證明(三個月內）資料不正確", value: 20 },
  { label: "背景審查證明(三個月內）資料已過期", value: 21 },
];

export const BANK = [
  { label: "渣打銀行（香港）", value: "StandardChartered" },
  { label: "香港上海滙豐銀行", value: "HSBC" },
  { label: "中國建設銀行（亞洲）", value: "中国建设银行" },
  { label: "中國銀行（香港）", value: "中國銀行" },
  { label: "東亞銀行", value: "BEA" },
  { label: "星展銀行（香港）", value: "DBS" },
  { label: "中信銀行（國際）", value: "CITIC" },
  { label: "招商永隆銀行", value: "永隆" },
  { label: "恒生銀行", value: "HANGSENG" },
  { label: "上海商業銀行", value: "上海商業銀行" },
  { label: "華僑永亨銀行", value: "OCBC" },
  { label: "大有銀行", value: "大有銀行" },
  { label: "集友銀行", value: "集友銀行" },
  { label: "大新銀行", value: "大新銀行" },
  { label: "創興銀行", value: "創興銀行" },
  { label: "南洋商業銀行", value: "NCB" },
  { label: "大生銀行", value: "大生銀行" },
  { label: "中國工商銀行（亞洲）", value: "ICBC" },
  { label: "富邦銀行（香港）", value: "富邦銀行" },
  { label: "交通銀行（香港）", value: "交通銀行" },
  { label: "摩根史坦利銀行（亞洲）", value: "Morgan" },
];

export const PAYMENT_MAPPING = {
  cash: "現金付款",
  card: "信用卡付款",
  wallet: "錢包付款",
};

export const MEMBER_TYPE = {
  PERSONAL: 0,
  COMPANY: 1,
};

export const MEMBER_STATUS = {
  PENDING: 0,
  APPROVAL: 1,
  REJECT: 2,
};

export const MEMBER_STATUS_MAPPING = {
  PENDING: "審批中",
  APPROVAL: "正常",
  REJECTED: "已拒絕",
};

export const MEMBER_STATUS_NUMBER_MAPPING = {
  0: "審批中",
  1: "正常",
  2: "已拒絕",
};

export const JOB_STATUS_MAPPING = {
  0: { label: "等待新增轉數", color: "warning" },
  1: { label: "等待司機接單", color: "info" },
  2: { label: "所有司機已接單", color: "secondary" },
  3: { label: "工作已完成", color: "success" },
  4: { label: "工作已取消", color: "danger" },
};

export const QUOTING_STATUS_MAPPING = {
  0: { label: "報價中", color: "secondary" },
  1: { label: "已確定報價", color: "warning" },
  2: { label: "司機已上貨", color: "info" },
  3: { label: "司機已送貨", color: "success" },
  4: { label: "已取消", color: "danger" },
};

export const QUOTING_STATUS = {
  NON_PAYMENT: 0,
  PAID: 1,
  PICKED_CLIENT: 2,
  DONE: 3,
};

export const trafficTicketBillyTypeOption = [
  { value: "01", label: "01" },
  { value: "02", label: "02" },
  { value: "03", label: "03" },
  { value: "04", label: "04" },
];

//'company','driver','company_and_driver','vendor','other'
export const trafficTicketResponsibilityOption = [
  { value: "company", label: "公司負責" },
  { value: "driver", label: "員工負責" },
  { value: "company_and_driver", label: "公司及員工共同負責" },
  { value: "vendor", label: "外判商負責" },
  { value: "other", label: "其他及補充資料" },
];

export const trafficTicketReasonOption = [
  { value: 1, label: "下班在公司指定地方泊車收到告票" },
  { value: 2, label: "下班未在公司指定地方泊車收到告票(請填寫以下主管已申請可以泊車位置及事發地點)" },
  { value: 3, label: "因人手不足，與跟車送貨，回車後發現有告票" },
  { value: 4, label: "此車輛為未出勤/後備之車輛" },
  { value: 5, label: "因沒有合適位置落貨而被抄牌" },
  { value: 6, label: "附近沒有停車場/錶位，回車時發現已發出告票" },
  { value: 7, label: "沒有３/４號碼頭泊車允許証，所以被抄牌" },
  { value: 8, label: "沒有靠左行駛" },
  { value: 9, label: "沒有出示有效行車證" },
  { value: 10, label: "超重" },
  { value: 11, label: "此車輛為閒置車" },
  { value: 12, label: "其他" },
];
export const OrderApprovalStatusOption = [
  { value: 0, label: "未核實", color: "secondary" },
  { value: 1, label: "車隊核實", color: "success" },
  { value: 2, label: "客管核實", color: "info" },
];

export const OrderStatusOption = [
  // { value: 0, label: "未付款" },
  // { value: 1, label: "已付款，未接單" },
  { value: 2, label: "已指派", color: "info" },
  { value: 3, label: "已上貨", color: "secondary" },
  { value: 4, label: "已完成", color: "success" },
  { value: 5, label: "已取消", color: "danger" },
  { value: 6, label: "異常", color: "danger" },
];

export const OrderCashCollectionOption = [
  { value: 0, label: "未收取" },
  { value: 1, label: "已收取" },
]

export const QUOTING_STATUS_OPTIONS = [
  { value: 0, label: "報價中" },
  { value: 1, label: "已確定報價" },
  { value: 2, label: "司機已上貨" },
  { value: 3, label: "司機已送貨" },
];

export const JobStatusOption = [
  { value: 0, label: "等待新增轉數" },
  { value: 1, label: "等待司機接單" },
  { value: 2, label: "所有司機已接單" },
  { value: 3, label: "工作已完成" },
  { value: 4, label: "工作已取消" },
];

export const PaymentOption = [
  { value: 0, label: "現金單" },
  { value: 1, label: "信用卡" },
  { value: 2, label: "錢包" },
  { value: 3, label: "公司單" },
];

export const QUOTING_PAYMENT_OPTIONS = [
  { value: 1, label: "信用卡" },
  { value: 2, label: "錢包付款" },
];

export const UPLOAD_TEMPLATE_TYPE_OPTIONS = [
  { value: 0, label: "司機", url: "https://s3.ap-southeast-1.amazonaws.com/file.speedd.hk/sample/driver_upload_template_tms.xlsx" },
  { value: 1, label: "柯打", url: "https://s3.ap-southeast-1.amazonaws.com/file.speedd.hk/sample/order_upload_template_tms.xlsx" },
  { value: 2, label: "地址處理", url: "https://s3.ap-southeast-1.amazonaws.com/file.speedd.hk/sample/address_upload_template.xlsx" },
  { value: 2, label: "特選客戶CBF", url: "https://s3.ap-southeast-1.amazonaws.com/file.speedd.hk/sample/cbf_upload_template.xlsx" },
  { value: 2, label: "特選客戶車線", url: "https://s3.ap-southeast-1.amazonaws.com/file.speedd.hk/sample/trending_client_routing_upload_template.xlsx" },
]

export const ADMIN_TYPE = [
  { value: 0, label: "super" },
  { value: 1, label: "車隊" },
  { value: 2, label: "客管" },
  { value: 3, label: "財務" },
  { value: 4, label: "客戶" },
  { value: 5, label: "人事部" },
];

export const OIL_STATUS_MAPPING = {
  0: "Submitted",
  1: "Pending",
  2: "Approved",
  3: "Rejected",
  4: "Cancelled",
};

export const VOUCHER_STATUS_OPTIONS = [
  { value: 0, label: "草稿" },
  { value: 1, label: "可使用" },
  { value: 2, label: "停止" },
];

export const DISTRICT_LIST_OPTIONS = [
  { value: 4, label: "淺水灣" },
  { value: 5, label: "赤柱" },
  { value: 6, label: "赤柱" },
  { value: 7, label: "大坑" },
  { value: 8, label: "薄扶林" },
  { value: 10, label: "薄扶林" },
  { value: 11, label: "深水灣" },
  { value: 12, label: "香港仔" },
  { value: 13, label: "海怡半島" },
  { value: 14, label: "南區" },
  { value: 15, label: "山頂" },
  { value: 16, label: "西半山" },
  { value: 18, label: "上環" },
  { value: 19, label: "中環" },
  { value: 20, label: "中半山" },
  { value: 21, label: "金鐘" },
  { value: 22, label: "灣仔" },
  { value: 23, label: "銅鑼灣" },
  { value: 24, label: "跑馬地" },
  { value: 25, label: "灣仔" },
  { value: 26, label: "跑馬地" },
  { value: 27, label: "大坑" },
  { value: 28, label: "大坑" },
  { value: 29, label: "北角" },
  { value: 30, label: "北角" },
  { value: 31, label: "鰂魚涌" },
  { value: 32, label: "太古" },
  { value: 34, label: "筲箕灣" },
  { value: 35, label: "杏花村" },
  { value: 36, label: "柴灣" },
  { value: 38, label: "西灣河" },
  { value: 39, label: "炮台山" },
  { value: 40, label: "天后" },
  { value: 41, label: "西營盤" },
  { value: 42, label: "堅尼地城" },
  { value: 44, label: "黃竹坑" },
  { value: 45, label: "鴨脷洲" },
  { value: 133, label: "石澳" },
  { value: 134, label: "石塘咀" },
  { value: 52, label: "藍田" },
  { value: 54, label: "觀塘" },
  { value: 55, label: "新蒲崗" },
  { value: 56, label: "九龍灣" },
  { value: 57, label: "黃大仙" },
  { value: 58, label: "九龍城" },
  { value: 59, label: "九龍塘" },
  { value: 60, label: "何文田" },
  { value: 61, label: "石硤尾" },
  { value: 62, label: "深水埗" },
  { value: 63, label: "長沙灣" },
  { value: 64, label: "荔枝角" },
  { value: 65, label: "美孚" },
  { value: 67, label: "大角咀" },
  { value: 68, label: "大角咀" },
  { value: 69, label: "佐敦" },
  { value: 70, label: "太子" },
  { value: 71, label: "旺角" },
  { value: 72, label: "油麻地" },
  { value: 73, label: "佐敦" },
  { value: 74, label: "尖沙咀" },
  { value: 75, label: "紅磡" },
  { value: 76, label: "黃埔" },
  { value: 77, label: "土瓜灣" },
  { value: 78, label: "九龍塘" },
  { value: 79, label: "鑽石山" },
  { value: 80, label: "葵涌" },
  { value: 81, label: "牛頭角" },
  { value: 82, label: "九龍灣" },
  { value: 127, label: "彩虹" },
  { value: 129, label: "樂富" },
  { value: 131, label: "油塘" },
  { value: 100, label: "西貢" },
  { value: 101, label: "馬鞍山" },
  { value: 102, label: "沙田" },
  { value: 103, label: "大埔" },
  { value: 104, label: "粉嶺" },
  { value: 105, label: "上水" },
  { value: 107, label: "元朗" },
  { value: 108, label: "天水圍" },
  { value: 110, label: "屯門" },
  { value: 111, label: "深井(屯門)" },
  { value: 112, label: "深井(荃灣)" },
  { value: 113, label: "荃灣" },
  { value: 114, label: "葵涌" },
  { value: 122, label: "葵涌" },
  { value: 123, label: "青衣" },
  { value: 124, label: "大圍" },
  { value: 125, label: "將軍澳" },
  { value: 126, label: "火炭" },
  { value: 130, label: "太和" },
  { value: 132, label: "葵涌" },
  { value: 136, label: "清水灣" },
  { value: 23608, label: "日出康城" },
  { value: 115, label: "馬灣" },
  { value: 116, label: "東涌" },
  { value: 117, label: "愉景灣" },
  { value: 118, label: "南大嶼山" },
  { value: 119, label: "坪洲" },
  { value: 120, label: "長洲" },
  { value: 121, label: "其他離島" },
  { value: 128, label: "南丫島" },
  { value: 135, label: "大澳" },
  { value: 23607, label: "迪士尼" },
];

export const DRIVER_TYPE = [
  { value: 1, label: "司機" }
]

export const ATTENDANCE_SUPPLEMENT_STATUS = [
  { value: 'in_progress', label: "待處理" },
  { value: 'accepted', label: "已接受" },
  { value: 'rejected', label: "已拒絕" },
]

export const IR_TYPE = [
  { label: "Form A 交通意外報告", value: "a" },
  { label: "Form C 投拆行為態度", value: "c" },
  { label: "Form D 派送意外", value: "d" },
  { label: "Form F 政府違例罰款", value: "f" },
  { label: "Form O 其他意外", value: "o" },
  { label: "Form W 倉內意外", value: "w" },
]

export const IR_STATUS = [
  { label: "已匯報", value: "normal" },
  { label: "待處理", value: "in_progress" },
  { label: "已審批", value: "approved" },
  { label: "已取消", value: "rejected" },
]

export const IR_PERSON_TYPE = [
  { label: "我", value: "我" },
  { label: "我的跟車/乘客", value: "我的跟車/乘客" },
  // { label: "途人", value: "途人" },
  // { label: "對方司機", value: "對方司機" },
  // { label: "對方乘客", value: "對方乘客" },
]

export const IR_WEATHER = [
  { label: "晴朗", value: "晴朗" },
  { label: "下雨", value: "下雨" },
  { label: "有霧", value: "有霧" },
]

export const IR_CONTACT_TYPE = [
  { label: "司機", value: "driver" },
  { label: "乘客", value: "passenger" },
  // { label: "途人", value: "pedestrian" },
  { label: "目擊者", value: "eyewitness" },
  { label: "證人", value: "witness" },
  { label: "其他", value: "other" },
]

export const IR_CONTACT_VEHICLE_TYPE = [
  { label: "私家車", value: "privateCar" },
  { label: "貨車", value: "truck" },
  { label: "其他", value: "other" },
]

export const leaveType = [
  { label: '年假', value: 'al' },
  { label: '病假', value: 'sl' },
  { label: '無薪假', value: 'upl' },
  { label: '補假', value: 'cl' },
]

export const leaveDayType = [
  { label: '全天', value: 'all' },
  { label: '上午', value: 'am' },
  { label: '下午', value: 'pm' },
]

export const leaveStatus = [
  { label: '待審批', value: 'in_progress' },
  { label: '已審批', value: 'approved' },
  { label: '已取消', value: 'rejected' },
]

export const voting_question_type = [
  { label: '選擇題', value: 'mc' },
  { label: '複數選擇題', value: 'check_box' },
  { label: '文字輸入', value: 'free_text' },
  { label: '分數', value: 'score' },
]

export const app_initial_page = [
  { label: '沒有', value: null },
  { label: '柯打記錄', value: 'OrderHistoryScreen' },
  { label: '倉庫首頁', value: 'WMSMainMenuScreen' },
]